<eds-panel theme="dark" [edsSpacing]="'none'">
  <div edsGrid *ngIf="showBreadcrumb">
    <div edsRow>
      <div edsCol>
        <!-- breadcrumbs  area -->
        <eds-breadcrumbs
          [items]="breadcrumbItems"
          theme="secondary-a"
          [removeBottomSpacing]="true"
        ></eds-breadcrumbs>
      </div>
    </div>
  </div>
  <div edsGrid>
    <div class="container container--wide" edsPadding edsPaddingTop="lg">
      <div edsRow alignItems="center">
        <!-- Title -->
        <div edsCol [columnNumbers]="colNumbers" edsSpacing="md" edsPadding>
          <div
            edsFlexbox
            [flexDirection]="(isHandheld$ | async) ? 'column' : 'row'"
            [alignItems]="(isHandheld$ | async) ? 'stretch' : 'center'"
            edsPadding
            edsPaddingTop="sm"
          >
            <eds-title
              size="h2"
              [level]="1"
              [isLight]="true"
              [title]="bannerTitle"
              edsPadding
              edsPaddingRight="sm"
            ></eds-title>

            <div
              edsFlexbox
              [flexDirection]="(isMobile$ | async) ? 'column' : 'row'"
              [alignItems]="(isMobile$ | async) ? 'stretch' : 'center'"
              edsPadding
              edsPaddingTop="xs"
            >
              <div
                edsFlexbox
                alignItems="center"
                [justifyContent]="(isMobile$ | async) ? 'space-between' : ''"
                aria-live="polite"
              >
                <!-- Spinner -->
                <div
                  class="document-filters__loader"
                  edsPadding
                  edsPaddingRight="sm"
                  *ngIf="!isLoaded"
                  aria-live="off"
                >
                  <ngx-spinner
                    name="documentLoadingSpinner"
                    bdColor="rgba(0,0,0,0)"
                    size="small"
                    color="#fff"
                    type="line-scale-party"
                    [fullScreen]="false"
                  >
                  </ngx-spinner>
                </div>

                <!-- Showing X of Y -->
                <p
                  *ngIf="isLoaded"
                  edsPadding
                  edsPaddingRight="sm"
                  edsSpacing="none"
                >
                  {{ "literature.lit-listing-shows" | translate }}
                  <b>{{ numberOfFliterData }}</b>
                  {{ "literature.lit-listing-of" | translate }}
                  <b>{{ totalNumberOfData }}</b>
                  {{ "literature.lit-listing-items" | translate }}
                </p>
                <eds-link-item
                  *ngIf="showDownloadExcel && isLoaded"
                  aria-live="off"
                  edsPadding
                  edsPaddingRight="sm"
                  title="{{ 'literature.download-all' | translate }}"
                  theme="dark"
                  [hasLeftIcon]="true"
                  type="xls"
                  iconSize="normal"
                  [stopNavigation]="false"
                  (click)="emitDownloadExcel($event)"
                ></eds-link-item>
              </div>
              <!-- Reset -->
              <ng-container *ngIf="showResetButton && isLoaded">
                <div
                  edsFlexbox
                  [justifyContent]="(isHandheld$ | async) ? 'flex-end' : ''"
                  edsPadding
                  [edsPaddingTop]="(isMobile$ | async) ? 'xs' : ''"
                >
                  <span
                    edsPadding
                    edsPaddingRight="sm"
                    *ngIf="(isMobile$ | async) !== true"
                    >|</span
                  >
                  <eds-link-item
                    theme="dark"
                    title="{{
                      'literature.lit-listing-filter-reset' | translate
                    }}"
                    (click)="resetFilters($event)"
                    [hasIcon]="true"
                    type="reset"
                    class="text-white"
                    eventId="form_filter"
                  ></eds-link-item>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- Product Type Filter -->
        <ng-container *ngIf="state?.primaryFilters">
          <ng-container
            *ngFor="let filterOptions of state.primaryFilters; let i = index"
          >
            <ng-container
              *ngIf="
                pageType ===
                  LiteraturePageType.REGULATORY_FUND_DOCUMENTS_GLOBAL &&
                filterOptions.options.length > 0 &&
                filterOptions.type.key === 'PRODUCT_TYPE'
              "
            >
              <eds-dropdown
                edsCol
                [columnNumbers]="{ s: 4, m: 3, l: 'auto' }"
                edsSpacing="md"
                [dropdownId]="filterOptions.type.key"
                [name]="filterOptions.type.key"
                label="{{ 'literature.' + filterOptions.label | translate }}"
                [items]="filterOptions.options"
                [preselectedValue]="filterOptions.preSelectedValues"
                titleText="{{
                  'literature.lit-listing-filter-select' | translate
                }}"
                selectedText="{{
                  'literature.lit-listing-filter-selected' | translate
                }}"
                [required]="false"
                [multi]="true"
                (dropdownChange)="
                  updateFilter('primary', filterOptions.label, $event)
                "
                eventType="form_filter"
                #filtersDropDowns
              ></eds-dropdown>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>

      <div edsRow>
        <!-- dropdown Skeleton Loader -->
        <ng-template #skeletonFilter>
          <ng-container
            *ngFor="let item of [].constructor(filterCount); let i = index"
          >
            <eds-dropdown
              [loading]="true"
              edsCol
              [columnNumbers]="{ s: 4, m: 2, l: 'auto' }"
              edsSpacing="md"
            ></eds-dropdown>
          </ng-container>
        </ng-template>

        <!-- dropdown content -->
        <ng-container *ngIf="state?.primaryFilters; else skeletonFilter">
          <ng-container
            *ngFor="let filterOptions of state.primaryFilters; let i = index"
          >
            <ng-container
              *ngIf="
                filterOptions.options.length > 0 &&
                !(
                  filterOptions.type.key === 'PRODUCT_TYPE' &&
                  pageType ===
                    LiteraturePageType.REGULATORY_FUND_DOCUMENTS_GLOBAL
                )
              "
            >
              <eds-dropdown
                edsCol
                [columnNumbers]="{ s: 4, m: 3, l: 'auto' }"
                [isActiveMenuLeft]="isActiveMenuLeft"
                edsSpacing="md"
                [dropdownId]="filterOptions.type.key"
                [name]="filterOptions.type.key"
                label="{{ 'literature.' + filterOptions.label | translate }}"
                [items]="filterOptions.options"
                [preselectedValue]="filterOptions.preSelectedValues"
                titleText="{{
                  'literature.lit-listing-filter-select' | translate
                }}"
                selectedText="{{
                  'literature.lit-listing-filter-selected' | translate
                }}"
                [required]="false"
                [multi]="true"
                (dropdownChange)="
                  updateFilter('primary', filterOptions.label, $event)
                "
                eventType="form_filter"
                #filtersDropDowns
              ></eds-dropdown>
            </ng-container>
          </ng-container>
        </ng-container>
        <!-- Search box loaded -->
        <ng-container *ngIf="state?.searchKeyword; else skeletonSearch">
          <eds-search
            edsCol
            edsSpacing="md"
            [columnNumbers]="{ s: '4', m: '3', l: 'auto' }"
            [label]="state.searchKeyword.type.key"
            placeholder="{{
              'literature.lit-listing-filter-search' | translate
            }}"
            fieldId="search__field"
            (searchTerm)="searchByKeyword($event)"
            [value]="
              state.searchKeyword?.selected
                ? state.searchKeyword?.selected[0]
                : ''
            "
            #filterSearch
          ></eds-search>
        </ng-container>

        <!-- Search box Skeleton loader-->
        <ng-template #skeletonSearch>
          <div edsRow edsSpacing="md">
            <!-- <eds-search edsCol [loading]="true"></eds-search> -->
          </div>
        </ng-template>
      </div>
      <div edsRow>
        <div edsCol>
          <!-- Additional-Filter box content -->
          <eds-accordion
            theme="basic"
            *ngIf="state?.additionalFilters?.length > 0"
          >
            <eds-accordion-item
              [noPadding]="true"
              edsSpacing="md"
              theme="dark"
              title="{{ 'literature.lit-additional-filter' | translate }}"
            >
              <div edsRow>
                <ng-container
                  *ngFor="
                    let filterOptions of state.additionalFilters;
                    let i = index
                  "
                >
                  <ng-container *ngIf="filterOptions.options.length > 0">
                    <eds-dropdown
                      edsCol
                      [columnNumbers]="{ s: 4, m: 3, l: 'auto' }"
                      edsSpacing="md"
                      [dropdownId]="filterOptions.type.key"
                      [name]="filterOptions.type.key"
                      label="{{
                        'literature.' + filterOptions.label | translate
                      }}"
                      [items]="filterOptions.options"
                      [preselectedValue]="filterOptions.preSelectedValues"
                      titleText="{{
                        'literature.lit-listing-filter-select' | translate
                      }}"
                      selectedText="{{
                        'literature.lit-listing-filter-selected' | translate
                      }}"
                      [required]="false"
                      [multi]="true"
                      (dropdownChange)="
                        updateFilter('additional', filterOptions.label, $event)
                      "
                      eventType="form_filter"
                      #filtersDropDowns
                    ></eds-dropdown>
                  </ng-container>
                </ng-container>
              </div>
            </eds-accordion-item>
          </eds-accordion>
        </div>
      </div>
    </div>
  </div>
</eds-panel>
